// FORGED Ed Systems — DEPLOY003 — v0.3.0 — IntakeStep6Optional.tsx
// Last touched: 2026-05-19
//
// Step 6 of intake: Optional context. Single open-text accordion for v1.
// Future deploys expand this into the full optional-fields accordion from
// the form mockup (tech comfort, strongest/weakest processes, etc.).

type Props = {
  value: string;
  onChange: (v: string) => void;
};

export default function IntakeStep6Optional({ value, onChange }: Props) {
  return (
    <div>
      <h2>Optional — additional context for a deeper plan</h2>
      <p className="step-description">
        Skipping this is fine. The plan will be coarser but still useful. Tell us
        anything else that affects how you're operating — instructor tech comfort,
        strongest and weakest welding processes, accommodations data, current
        curriculum quirks, anything we should know.
      </p>

      <label className="field">
        <span>Additional context (optional)</span>
        <textarea
          rows={8}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Anything that would change the strategy. Examples:&#10;- 7 students with IEPs, mostly reading/processing speed accommodations&#10;- Strongest process: GMAW. Weakest: GTAW&#10;- 4 lab benches need maintenance, may be down for 2 weeks in October"
        />
      </label>
    </div>
  );
}
